import type { RouteRecordRaw } from 'vue-router';

export enum CompanyDetailsRoute {
    Selection = 'client-company-details',
    Info = 'client-company-details-info',
    Documents = 'client-company-details-documents',
}

/**
 * Mounted under `/dashboard/client` by `dashboard.router.ts`. The entity comes from `:id`,
 * never from the selected entity — see `docs/adr/0031-entity-pages-take-the-entity-from-the-url.md`.
 */
export const companyDetailsRoutes: RouteRecordRaw = {
    path: 'company-details',
    meta: { title: 'COMPANY_DETAILS' },
    children: [
        {
            path: '',
            name: CompanyDetailsRoute.Selection,
            component: () => import('./views/CompanySelection.vue'),
        },
        {
            // Each tab is a child route, so the open tab survives reloads and deep links.
            path: ':id',
            component: () => import('./views/CompanyDetails.vue'),
            children: [
                {
                    path: '',
                    name: CompanyDetailsRoute.Info,
                    component: () => import('./components/CompanyInfoTab.vue'),
                },
                {
                    path: 'documents',
                    name: CompanyDetailsRoute.Documents,
                    component: () => import('./components/DocumentsTab/DocumentsTab.vue'),
                },
            ],
        },
    ],
};
